/**
 * The access-token cookie is short-lived (15 minutes — see EPN.Identity.Api's Jwt:AccessTokenLifetimeMinutes)
 * and nothing was silently renewing it: every Http*Gateway just threw a bare 401 once it expired, on
 * whatever authenticated call happened to be the next one — reported live as "Request to
 * /api/me/switch-company failed with 401", but really any endpoint, any module, after 15 minutes of
 * activity. This is the shared fix: attempt POST /api/auth/refresh once and let the caller retry.
 *
 * The in-flight promise is deliberately module-level and shared across every caller, not per-request —
 * IRefreshTokenService.ValidateAndRotateAsync revokes the old refresh token and issues a new one
 * atomically, so if several requests 401 around the same moment and each fired its own refresh call, only
 * the first would succeed and every other would itself get a 401 trying to reuse an already-rotated
 * token. Deduplicating to one in-flight refresh, awaited by everyone, avoids that race entirely.
 */
let inFlightRefresh: Promise<boolean> | null = null;

export function refreshAccessToken(): Promise<boolean> {
  if (!inFlightRefresh) {
    inFlightRefresh = fetch('/api/auth/refresh', { method: 'POST', credentials: 'include' })
      .then((response) => response.ok)
      .catch(() => false)
      .finally(() => {
        inFlightRefresh = null;
      });
  }
  return inFlightRefresh;
}
